import React from "react"
import PropTypes from "prop-types"

import { getParcelStatusName } from "shared/utils"

import CountryLabel from "shared/components/CountryLabel"

import styles from "./BasicInformationTable.css"

const BasicInformationTable = ({ shipment }, { t: translate }) => (
  <table className={styles.table}>
    <thead>
      <tr>
        <th colSpan="2">{translate("Basic parcel information")}</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <th>{translate("destination")}</th>
        <td className="destination">
          <CountryLabel
            code={shipment.destination.country}
            label={<span>{shipment.destination.city}, {shipment.destination.country}, {shipment.destination.postal_code}</span>}
          />
        </td>
      </tr>
      <tr>
        <th>{translate("Current status")}</th>
        <td className="w500">{getParcelStatusName(shipment.status)}</td>
      </tr>
    </tbody>
  </table>
)

BasicInformationTable.propTypes = {
  shipment: PropTypes.shape({
    destination: PropTypes.shape({
      country: PropTypes.string.isRequired,
      city: PropTypes.string.isRequired,
      postal_code: PropTypes.string.isRequired,
    }),
    status: PropTypes.string.isRequired,
  }).isRequired,
}
BasicInformationTable.contextTypes = {
  t: PropTypes.func.isRequired,
}

export default BasicInformationTable



// WEBPACK FOOTER //
// ./src/views/Parcel/components/Information/BasicInformationTable/BasicInformationTable.js